<template>
  <div
    ref="target"
    :class="{ '!bg-grey-600': isDropdownOpen }"
    class="default-button-height min-w-32 text-h7 relative flex cursor-pointer select-none items-center justify-between rounded border border-grey-600 px-4 text-sm"
    @click="handleDropdownClick"
  >
    <div class="flex items-center">
      {{ selectedOption || defaultLabel }}
    </div>
    <ChevronDown
      :class="{ 'rotate-180': isDropdownOpen }"
      class="h-5 w-5 transition-transform"
    />

    <div
      v-if="isDropdownOpen"
      class="absolute left-0 top-[calc(100%_+_4px)] z-10 w-full cursor-pointer rounded bg-white text-black transition-all"
      style="box-shadow: 0 1px 10px 0 #c1c5cf"
    >
      <div
        v-for="option in options"
        :key="option"
        class="border-b border-s-300 p-4 transition-colors flex justify-between items-center"
        :class="
          selectedOption === option
            ? 'bg-p-200 font-semibold'
            : 'font-normal hover:bg-s-100 '
        "
        @click.stop="selectOption(option)"
      >
        {{ option }}
        <template v-if="selectedOption === option">
          <div class="flex items-center size-4">
            <CommonIcon class="size-5" name="IconCheck" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

import ChevronDown from '~/assets/icons/ChevronDown.svg'
import CommonIcon from '~/components/common/Icon.vue'

type TDropdownValue = string | number

const props = withDefaults(
  defineProps<{
    options: TDropdownValue[]
    defaultLabel?: string
    modelValue?: string | number
  }>(),
  {
    defaultLabel: 'Select an option',
  },
)

const emit = defineEmits<{
  'update:modelValue': [TDropdownValue]
  change: [TDropdownValue]
}>()

const target = ref(null)
const isDropdownOpen = ref(false)

const selectedOption = computed(() => {
  return props.options.find((option) => option === props.modelValue)
})

const handleDropdownClick = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const selectOption = (option: TDropdownValue) => {
  emit('update:modelValue', option)
  emit('change', option)
  closeDropdown()
}

const closeDropdown = () => {
  isDropdownOpen.value = false
}

onClickOutside(target, () => {
  closeDropdown()
})
</script>
